import $ from 'jquery'

import getTypes                     from './getTypes'
import formatData                   from './formatData'
import { showLoading, hideLoading } from '../render/loading'
import { showError }                from '../render/errors'
import { render }                   from '../render/message'

let types

/**
 * Checks that message types are populated, and gets them if not; then gets
 * the message data by ID.
 *
 * @param string
 * @return void
 */
const requestMessage = id => {

  showLoading()

  let time = Date.now()

  if ( typeof types !== 'object' )
    getTypes( data => {
      types = {}
      Object.entries( data ).forEach( ( [ key, value ] ) => types[ value.id ] = value.name )
      getMessage( id, time )
    } )
  else
    getMessage( id, time )

}

/**
 * Gets message data from the server and formats into a message object, then
 * passes to the renderer
 *
 * @param string
 * @return void
 */
const getMessage = ( id, startTime ) => {

  const data = {
          action   : 'your-chat/get-qna',
          id       : id,
          security : window.your_chat.ajax_nonce,
        }

  $.post( ajaxurl, data )

   .done( response => {

      if ( !response.success )
        return showError( response.message );

      let timeNow   = Date.now(),
          timeLeft  = Math.max( 1500 - timeNow + startTime, 0 ),
          result = formatData( response.data )

      setTimeout( () => {
        render( createMessage( result ) );
        hideLoading()
      }, timeLeft )


   } )

   .fail( ( xhr, status, error ) => showError() )

}

/**
 * Formats data from server into a message object
 *
 * @param object
 * @return object
 */
const createMessage = data => {

  if ( typeof data !== 'object' || data === null )
    showError()

  // Set type
  if (
    typeof data.qnATypeId          !== 'string' ||
    typeof types[ data.qnATypeId ] !== 'string'
  )
    data.qnATypeId = 'Answer'
  else
    data.qnATypeId = types[ data.qnATypeId ]

  // Handle undefined or null children
  if ( !data.childQnAs )
    data.childQnAs = []

  // Ensure children are in array
  if (
    typeof data.childQnAs !== 'object' ||
    !Array.isArray( data.childQnAs )
  )
    data.childQnAs = [ data.childQnAs ]

  // Set text
  if ( typeof data.qText !== 'string' )
    data.qText = ''

  // Set text
  if ( typeof data.id !== 'string' )
    data.id = ''

  return {
    type    : data.qnATypeId,
    options : data.childQnAs,
    text    : data.qText,
    user    : 'bot',
    id      : data.id
  }

}

export default id => requestMessage( id )
